<template lang="pug" id="idea-modal">
.modal-backdrop(role="dialog" @mousedown.stop="close" v-if="data")
  .idea-modal.column(@mousedown.stop @click.stop)
    .wrapper.column.flex-1(style="min-height: fit-content;")
      //- HEADER
      .header.row.center.between
        .badge(:class="data.status") {{ t[data.status] || data.status }}
        .actions.row.center.right
          .deny.icon.row.center(v-if="$root.permissions.includes('confirm')" :class="{active: data.status === 'denied'}" @click="deny_idea")
            font-awesome-icon(icon="minus")
          .confirm.icon.row.center(v-if="$root.permissions.includes('confirm')" :class="{active: data.status === 'confirmed'}" @click="confirm_idea")
            font-awesome-icon(icon="check")
          .schedule.icon.row.center(v-if="$root.permissions.includes('publish')" @click="publish" :class="{ green: linked_post }")
            svg-icon(name="calendar-plain")
          .close.icon.row.center(@click="close")
            font-awesome-icon(icon="times")
      .created-by.row.center.left
        .icon
          svg-icon(icon="author")
        div Par {{ data.created_by }}, le {{ new Date(data.date_created).format('%d %b %Y', $root.lang) }}
      .created-by.row.center.left(v-if="data.status === 'confirmed'")
        .icon.confirm
          svg-icon(icon="confirmed")
        div Par {{ data.confirmed_by }}, le {{ new Date(data.date_confirmed || 0).format('%d %b %Y', $root.lang) }}
      .created-by.row.center.left(v-if="data.status === 'denied'")
        .icon
          svg-icon(icon="denied")
        div Par {{ data.denied_by }}, le {{ new Date(data.date_denied || 0).format('%d %b %Y', $root.lang) }}
      .title(v-if="new_title")
        textarea(v-model="new_title")
        .row.center.right
          button.red(@click="new_title = null;") {{ t.cancel }}
          button(@click="save_title" :class="(new_title === data.description) ? 'disabled' : 'green'") {{ t.save }}
      .title(v-else :class="{ disabled: data.author_id !== $root.user_id && !$root.permissions.includes('manage')}" @click="new_title = data.title;") {{ data.title }}
      .category {{ t.in_the_category }} {{ $root.account_boxes[data.box_id].title }}
      .publication.row.center.between(:class="{ disabled: data.author_id !== $root.user_id && !$root.permissions.includes('manage')}")
        date-picker.row.center.left.flex-1(@select="$root.change_idea(data.id, 'publication_date', $event)" :date="data.publication_date" :metadata="{date_format: d => d.format('%d %b %Y', $root.lang) }" :domain="[new Date().format('%Y-%m-%d'), new Date().advance('3 years').format('%Y-%m-%d')]")
          template(slot="date" slot-scope="{ displayed_date, selected_date}")
            .publication-date.suggested.row.center.left
              .icon
                svg-icon(icon="calendar")
              .column
                div {{ t.wanted_publication }}
                .date {{ data.publication_date ? new Date(data.publication_date).format('%d %b %Y', $root.lang) : t.click_to_add_publication_date }}
        .publication-date.flex-1.row.center.left(v-if="linked_post")
          .icon
            svg-icon(icon="calendar")
          .column
            div {{ t.scheduled_publication }}
            .date {{ new Date(linked_post.date).format('%d %b %Y', $root.lang) }}
      .description(v-if="new_description !== null")
        textarea(v-model="new_description")
        .row.center.right
          button.red(@click="new_description = null;") {{ t.cancel }}
          button(@click="save_description" :class="(new_description === data.description) ? 'disabled' : 'green'") {{ t.save }}
      .description(v-else :class="{ disabled: data.author_id !== $root.user_id && !$root.permissions.includes('manage')}" @click="new_description = data.description || '';") {{ data.description }}
      .image.row.center
        image-wrapper(:data="data.images" @delete="$root.delete_image(data.id,$event)" @fullscreen="fullscreen = $event")
      button.upload.flat.row.center.left(v-if="data.author_id === $root.user_id" @mousedown.stop @click.stop.prevent="click_upload")
        .icon
          svg-icon(icon="upload")
        div {{ t.add_attachment }}
      input(@mousedown.stop @click.stop type="file" id="file" ref="file" @change="$root.multiple_file_upload($event, data.id)" hidden multiple)
      .comments-title.row.center.left
        .icon
          svg-icon(icon="comments")
        div {{ t.comments }}
      .comment.column(v-for="comment in comments")
        .row.center.between
          .badge {{ comment.author }}
          .date {{ new Date(comment.date).format('%d %b %H:%M', $root.lang) }}
        .text {{ comment.text }}
      .new-comment.column(@click="focus_textarea")
        textarea#comment-textarea(v-model="new_comment_text" :placeholder="t.write_comment")
        .row.center.right
          button(@click.stop.prevent="$root.new_comment(data.id, new_comment_text);new_comment_text=null;" :class="[new_comment_text ? 'green' : 'inactive']") {{ t.submit }}
</template>
<script>
export default {
  props: ['idea_id', 'calendar_id'],
  data() {
    return {
      new_comment_text: null,
      data: null,
      new_description: null,
      new_title: null,
      new_publication_date: null,
      linked_post: null,
    }
  },
  mounted() {
    bind_key(this, 'data', `public/ideas/${this.$root.active_box_account.id}/${this.idea_id}`)
  },
  watch: {
    'data.post_id': {
      handler(newVal, oldVal) {
        if (newVal === oldVal) return
        if (!newVal || !this.calendar_id) return
        bind_key(this, 'linked_post', `public/posts/${this.calendar_id}/${newVal}`)
      },
      immediate: true,
    },
  },
  computed: {
    pretty_text() {
      // return this.data.text.replace(/#(\S+)/g, '<u>#$1</u>').replace(/@(\S+)/g, '<u>@$1</u>').replace(/(?:\r\n|\r|\n)/g, '<br />');
    },
    comments() {
      if (!this.data) return
      if (!this.data.comments) return []
      return this.data.comments
        .vls()
        .sortBy(d => d.date)
        .filter(d => d.text)
    },
    // linked_post() {
    //   if (!this.data.post_id || !this.calendar) return
    //   return this.calendar[this.data.post_id]
    // }
  },
  methods: {
    click_upload() {
      document.querySelector('#file').click()
    },
    close() {
      this.$root.modal = null
    },
    focus_textarea() {
      document.querySelector('#comment-textarea').focus()
    },
    save_description() {
      this.$root
        .change_idea(this.data.id, 'description', this.new_description)
        .then(() => (this.new_description = null))
    },
    save_title() {
      this.$root
        .change_idea(this.data.id, 'title', this.new_title)
        .then(() => (this.new_title = null))
    },
    confirm_idea() {
      this.$root.change_status(this.data.id, 'confirmed').then(() => {
        this.$root.change_idea(this.data.id, 'confirmed_by', this.$root.user.name)
        this.$root.change_idea(this.data.id, 'date_confirmed', new Date().toISOString())
      })
    },
    deny_idea() {
      const text = this.$root.t.deny_text
      const confirm = () =>
        this.$root.change_status(this.data.id, 'denied').then(() => {
          this.$root.change_idea(this.data.id, 'denied_by', this.$root.user.name)
          this.$root.change_idea(this.data.id, 'date_denied', new Date().toISOString())
        })
      this.$root.confirm_modal = {
        text,
        confirm,
        cancel: () => null,
      }
    },
    publish() {
      if (!this.calendar_id) return alert('No linked calendar')
      // if (!this.data.publication_date) return alert('Choose a publication date first')
      if (this.linked_post) return this.open_post(this.data.post_id)
      this.$root
        .new_post(this.calendar_id, this.data)
        .then(post_id =>
          this.$root
            .change_idea(this.data.id, 'post_id', post_id)
            .then(() => this.open_post(post_id))
        )
    },
    open_post(post_id) {
      post_id = post_id || this.data.post_id
      if (!post_id) return alert('Error')
      window.open(
        `https://calendar.labellecom.fr/home?account_id=${this.calendar_id}&post_id=${post_id}`
      )
    },
  },
}
</script>
<style>
.idea-modal {
  --width: 480px;
  position: fixed;
  padding: 16px;
  box-shadow: var(--box-shadow);
  border-radius: 0 16px 16px 16px;
  background: white;
  left: calc(50vw - calc(var(--width) / 2));
  top: 100px;
  width: var(--width);
  min-height: fit-content;
  max-height: calc(100vh - 120px);
  overflow-y: scroll;
  z-index: 10;
}

.mobile:not(.laptop) .idea-modal {
  --width: 100vw;
  left: 0;
  top: var(--nav-top-height);
  min-height: 72vh;
  max-height: calc(calc(100vh - var(--nav-top-height)) - 32px);
  max-width: 100%;
}
.mobile:not(.laptop) .idea-modal .comments-title {
  margin-top: auto;
}

.idea-modal .header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
}
.idea-modal .header .icon {
  width: 32px;
  height: 32px;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 6px;
}
.idea-modal .header .close {
  color: var(--grey);
  border: 1px solid var(--grey);
  padding: 6px;
}
.idea-modal .header .icon.confirm,
.idea-modal .header .icon.deny {
  background: var(--text);
  color: white;
}
.idea-modal .header .icon.confirm.active {
  background: var(--green-bg);
}
.idea-modal .header .icon.deny.active {
  background: var(--red-bg);
}
.idea-modal .header .icon.schedule {
  background: rgba(0, 0, 0, 0.1);
}
.idea-modal .header .icon.schedule.green {
  background: var(--green-bg);
}

.idea-modal .created-by {
  color: var(--darkgrey);
  fill: var(--darkgrey);
  font-weight: 300;
  font-size: 12px;
  margin-bottom: 4px;
}
.idea-modal .created-by .icon.confirm {
  stroke: var(--darkgrey);
}
.idea-modal .created-by .icon {
  width: 26px;
  height: 26px;
  margin-right: 6px;
}
.idea-modal .created-by .icon.deny {
  border: 1px solid var(--darkgrey);
  padding: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.idea-modal .created-by .icon.deny svg {
  margin-bottom: 1px;
}
.idea-modal .title {
  font-size: 22px;
  font-weight: bold;
  margin-top: 8px;
}
.idea-modal .category {
  color: var(--darkgrey);
  font-weight: 300;
  font-size: 12px;
  margin-bottom: 16px;
}
.idea-modal .publication {
  margin-bottom: 12px;
}
.idea-modal .publication .date-picker {
  margin-right: 16px;
}
.idea-modal .publication-date {
  color: var(--darkgrey);
  font-size: 11px;
  font-weight: 300;
  margin-bottom: 8px;
  line-height: 1;
}
.idea-modal .publication-date.suggested:hover {
  cursor: pointer;
  outline: 2px solid var(--lightgrey);
}
.idea-modal .publication-date .date {
  font-weight: bold;
}
.idea-modal .publication-date .icon {
  width: 26px;
  height: 26px;
  margin-right: 4px;
  fill: var(--darkgrey);
}
.idea-modal .description textarea,
.idea-modal .title textarea {
  background: var(--background);
  width: 100%;
  font-size: 16px;
}
.idea-modal .description button,
.idea-modal .title button {
  margin-left: 6px;
}
.idea-modal .description {
  margin-bottom: 16px;
  min-height: 30px;
  background: var(--background);
  border-radius: 10px;
  padding: 8px;
}

.idea-modal .comments-title {
  font-weight: bold;
  margin-bottom: 8px;
}
.idea-modal .comments-title .icon {
  width: 26px;
  height: 26px;
  margin-right: 4px;
  fill: var(--darkgrey);
}
.idea-modal .new-comment,
.idea-modal .comment {
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 16px;
}
.idea-modal .new-comment textarea {
  font-size: 16px;
}
.idea-modal .comment {
  border: solid 1px #e2e2e2;
}
.idea-modal .comment .date {
  font-size: 11px;
}
.idea-modal .comment .text {
  margin-top: 8px;
}
.idea-modal .new-comment {
  background: var(--background);
}
.idea-modal textarea {
  resize: none;
}
.idea-modal button.upload {
  padding: 8px 0;
  margin-bottom: 16px;
  font-weight: bold;
}
.idea-modal button.upload .icon {
  width: 26px;
  height: 26px;
  margin-right: 6px;
}
</style>
